import React from "react";
import PropTypes from "prop-types";

import _ from "lodash";
import InputMask from "react-input-mask";

import "./styles/style.scss";

// eslint-disable-next-line react/display-name
const Input = React.forwardRef(
  ({ isError, isStretch, label, type, size, validationErrors, ...rest }, ref) => {
    /**
     * Вернуть класс, применяемый для размера поля ввода
     *
     * @param {String} value
     * @return {String}
     */
    const getSizeClass = value => {
      const classes = {
        xxl: "input--xxl",
        xl: "input--xl",
        lg: "input--lg",
        md: "input--md",
        sm: "input--sm",
        xs: "input--xs",
      };

      return _.get(classes, value, Input.defaultProps.size);
    };

    const { extraProps, children, ...domProps } = rest;
    const classNames = [
      "input",
      isError && "input--invalid",
      isStretch && "input--stretch",
      getSizeClass(size),
      extraProps && "input--dpicker",
      rest.className,
    ]
      .filter(name => name)
      .join(" ");

    return (
      <div className="input-container">
        {label && <div className="label-field">{label}</div>}

        {type === "tel" ? (
          <>
            <InputMask
              {...domProps}
              type="tel"
              className={classNames}
              mask={"+7 (\\999) 999 99 99"}
              maskChar={null}
            >
              {inputProps => <input ref={ref} {...inputProps} {...domProps} />}
            </InputMask>
          </>
        ) : (
          <>
            <div className="input-wrapper">
              <input ref={ref} {...extraProps} {...domProps} type={type} className={classNames} />
              {children}
            </div>
          </>
        )}

        {!!validationErrors.length && (
          <div className="input-errors">
            {validationErrors.map((error, index) => (
              <div key={index} className="input-errors__error">
                {error}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
);

Input.propTypes = {
  isError: PropTypes.bool,
  isStretch: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  size: PropTypes.string,
  validationErrors: PropTypes.array,
};

Input.defaultProps = {
  isError: false,
  isStretch: true,
  label: "",
  type: "text",
  size: "xl",
  validationErrors: [],
};

export default Input;
